import { useEffect, useRef } from 'react';

/**
 * Returns `watch(win, onClosed)`: calls `onClosed` once a `window.open` popup closes.
 * A null `win` (popup blocked) is ignored, and pending watches are dropped on unmount.
 */
export default function usePopupClosed() {
  const timers = useRef(new Set<ReturnType<typeof setInterval>>());

  useEffect(() => () => {
    timers.current.forEach(clearInterval);
    timers.current.clear();
  }, []);

  return (win: Window | null, onClosed: () => void) => {
    if (!win) return;
    const id = setInterval(() => {
      if (!win.closed) return;
      clearInterval(id);
      timers.current.delete(id);
      onClosed();
    }, 250);
    timers.current.add(id);
  };
}
